// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tsDLr","title":"styles_title__yuG0Y"};